import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-internet',
  templateUrl: './page-internet.component.html',
  styleUrls: ['./page-internet.component.css']
})
export class PageInternetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
